import { autoGroupSortingDefaults } from '@talos/kyoko';
import type { SortComparatorFn, ValueFormatterParams, ValueGetterParams } from 'ag-grid-community';
import { PriceGridRowKind, type PriceGridEntity } from './PriceGridEntity';

export function getPriceGridGroupColumnValue(params: ValueGetterParams<PriceGridEntity>) {
  const data = params.node?.data ?? params.data;
  if (data?.kind === PriceGridRowKind.Parent) {
    return data.security.Symbol;
  }

  return '';
}

export function formatPriceGridGroupColumnValue(params: ValueFormatterParams<PriceGridEntity>) {
  const data = params.node?.data ?? params.data;
  if (data?.kind === PriceGridRowKind.Parent) {
    return data.security.DisplaySymbol || data.security.Symbol;
  }

  return '';
}

export const priceGridTreeGroupComparator: SortComparatorFn<PriceGridEntity> = (
  valueA,
  valueB,
  nodeA,
  nodeB,
  isDescending
) => {
  if (nodeA?.data?.isParentRow === false && nodeB?.data?.isParentRow === false) {
    return 0;
  }

  const comparator = autoGroupSortingDefaults.comparator;
  return typeof comparator === 'function' ? comparator(valueA, valueB, nodeA, nodeB, isDescending) : 0;
};
